import React, { useState, useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import { ArrowForward, ArrowBack } from '@mui/icons-material';

export default function PaginatedDocument({ title, sections }) {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const nextStep = () => {
    if (currentStep < sections.length - 1) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  return (
    <div className="waya-paginated-doc-wrapper py-5">
      <div className="container mt-5">
        <Fade top>
          <div className="doc-header mb-5">
            <h6 className="waya-section-badge">Legal Document</h6>
            <h1 className="waya-section-title mt-2" style={{ color: 'var(--waya-primary)' }}>{title}</h1>
            
            {/* Progress indicator */}
            <div className="d-flex align-items-center gap-3 mt-4">
              <div className="flex-grow-1 bg-gray-100 rounded-full h-1 overflow-hidden" style={{ background: '#f2f4f7', height: '4px', borderRadius: '4px' }}>
                <div 
                  className="transition-all duration-500" 
                  style={{ 
                    width: `${((currentStep + 1) / sections.length) * 100}%`, 
                    height: '100%', 
                    background: 'var(--waya-primary)' 
                  }} 
                />
              </div>
              <span className="text-sm font-bold text-gray-500" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>
                Part {currentStep + 1} of {sections.length}
              </span>
            </div>
          </div>
        </Fade>

        <div className="doc-content-area shadow-sm bg-white p-4 p-md-5 rounded-3xl border border-gray-100 mb-5" style={{ borderRadius: '24px', border: '1px solid #f2f4f7' }}>
            <Fade spy={currentStep} duration={400}>
                <div className="legal-section-content">
                    <h2 className="mb-4" style={{ fontWeight: 800, fontSize: '28px' }}>{sections[currentStep].title}</h2>
                    <div className="legal-text-body" style={{ lineHeight: 1.8, fontSize: '17px', color: '#344054' }}>
                        {sections[currentStep].content}
                    </div>
                </div>
            </Fade>
        </div>

        {/* Navigation Buttons */}
        <div className="d-flex justify-content-between align-items-center mb-5">
          <button 
            onClick={prevStep}
            disabled={currentStep === 0}
            className="waya-page-btn d-flex align-items-center gap-2"
            style={{ 
              opacity: currentStep === 0 ? 0.3 : 1,
              padding: '12px 24px',
              borderRadius: '12px',
              border: '1px solid #eaecf0',
              background: 'white',
              fontWeight: 700
            }}
          >
            <ArrowBack fontSize="small" /> Previous Part
          </button>

          <button 
            onClick={nextStep}
            disabled={currentStep === sections.length - 1}
            className="waya-btn-primary d-flex align-items-center gap-2"
            style={{ 
                opacity: currentStep === sections.length - 1 ? 0 : 1,
                pointerEvents: currentStep === sections.length - 1 ? 'none' : 'auto',
                padding: '12px 24px',
                borderRadius: '12px',
                background: 'var(--waya-primary)',
                color: 'white',
                border: 'none',
                fontWeight: 700
            }}
          >
            Next Part <ArrowForward fontSize="small" />
          </button>
        </div>
      </div>
    </div>
  );
}
